<div class="container">
  <div class="row">
    <h1 class="page-title">{{ "RIDP_TITLE" | globalTranslate }}</h1>
  </div>
  @if (fromWp) {
  <div class="bg-custom-register">
    <nh-alert type="success" [isOpen]="displaySuccessBanner">
      <div class="row">
        <div class="col-auto icon">
          <img
            src="../../../../../assets/images/Icons/⚛️ icons-checkmark-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span
            [innerHTML]="'RIDP_CALLCENTER_STATIC13' | globalTranslate"
          ></span>
        </div>
      </div>
    </nh-alert>
    <h2 class="section-header">
      {{ "RIDP_CALLCENTER_STATIC1" | globalTranslate }}
    </h2>
    <hr />
    <p>{{ "RIDP_CALLCENTER_STATIC2" | globalTranslate }}</p>
    <p [innerHTML]="'RIDP_CALLCENTER_STATIC3' | globalTranslate"></p>
    <div>
      <h3 class="section-header">
        {{ "RIDP_CALLCENTER_STATIC4" | globalTranslate }}
      </h3>
      <hr />
      <p>{{ "RIDP_CALLCENTER_STATIC5" | globalTranslate }}</p>
      <table class="table w-75 table-striped" style="width: 60% !important">
        <thead>
          <tr>
            <th scope="col">
              {{ "RIDP_CALLCENTER_STATIC6" | globalTranslate }}
            </th>
            <th scope="col">
              {{ "RIDP_CALLCENTER_STATIC7" | globalTranslate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <b>{{ "FIRST_NAME" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.firstName }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "RIDP_MIDDLE_NAME" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.middleName }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "LAST_NAME" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.lastName }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "SUFFIX" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.suffix }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "DOB" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.dob | date: "MM/dd/yyyy" }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "SSN" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.ssn }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "ADDRESS_LINE_1" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.addressLine1 }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "ADDRESS_LINE_2" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.addressLine2 }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "CITY" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.city }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "STATE" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.state }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "ZIP_CODE" | globalTranslate }}</b>
            </td>
            <td>
              <span>{{ memberInfo.zipCode }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                ><b>{{ "ZIP_EXTENSION" | translate }}</b
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                  memberInfo.zipCodeExtension
                }}</span
              >
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ "COUNTY" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.county }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "PRIMARY_PHONE" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.primaryPhone }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "EMAIL_ADDRESS" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.emailAddress }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ "RIDP_CALLCENTER_STATIC8" | globalTranslate }}</b>
            </td>
            <td>{{ memberInfo.memberConsent }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <h4 class="section-header">
        {{ "RIDP_CALLCENTER_STATIC9" | globalTranslate }}
      </h4>
      <table class="table w-100 table-striped">
        <thead>
          <tr>
            <th scope="col">{{ "NAME" | globalTranslate }}</th>
            <th scope="col">{{ "DOCUMENT_TYPE" | globalTranslate }}</th>
            <th scope="col">{{ "UPLOAD_DATE" | globalTranslate }}</th>
            <th scope="col">{{ "Status" | globalTranslate }}</th>
            <th scope="col">{{ "View" | globalTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (doc of submittedDocuments; track doc) {
          <tr>
            <td>{{ doc.name }}</td>
            <td style="width: 30%">{{ doc.documentType | globalTranslate }}</td>
            <td>{{ doc.uploadDate | date: "MM/dd/yyyy" }}</td>
            <td>
              @if (doc?.statusCd === 'IP' && !displaySuccessBanner) {
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.5"
                  height="17.5"
                  viewBox="0 0 17.5 17.5"
                  style="margin-left: 2px"
                >
                  <g id="time-outline" transform="translate(-63.25 -63.25)">
                    <path
                      id="Path_154"
                      data-name="Path 154"
                      d="M72,64a8,8,0,1,0,8,8A8,8,0,0,0,72,64Z"
                      fill="#ed9924"
                      stroke="#ed9924"
                      stroke-miterlimit="10"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_155"
                      data-name="Path 155"
                      d="M256,128v6h4"
                      transform="translate(-184 -61.333)"
                      fill="#ed9924"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
                &nbsp; <b>{{ doc.status | globalTranslate }}</b
                >@if (doc.status) {
                <nh-popover
                  class="ps-1"
                  content="The member has submitted documents for review to complete the identity verification process. You must review the information provided by the member and complete the Manual Identity Verification section below."
                ></nh-popover>
                }
              </span>
              } @if ((displaySuccessBanner || doc?.statusCd !== 'IP') &&
              isVerificationDisabled) {
              <span>
                <b>Review Completed</b>
              </span>
              }
            </td>
            <td>
              <a
                class="btn btn-link view-link"
                tabindex="0"
                (click)="onViewPdf(doc.filenetId)"
                >{{ "View" | globalTranslate }}
                <i
                  class="fa fa-search"
                  aria-hidden="true"
                  [attr.aria-label]="'VIEW' | globalTranslate"
                ></i
              ></a>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    <div>
      <h5 class="section-header">
        {{ "RIDP_CALLCENTER_STATIC10" | globalTranslate }}
      </h5>
      <hr />
      <p [innerHTML]="'RIDP_CALLCENTER_STATIC11' | globalTranslate"></p>
      <nh-field
        [attr.aria-required]="true"
        [isRow]="true"
        label="{{ 'RIDP_CALLCENTER_STATIC12' | globalTranslate }}"
      >
        <select
          class="custom-select-info"
          aria-label="verificationStatusOptions"
          [(ngModel)]="verificationStatus"
          [disabled]="isVerificationDisabled"
        >
          <option [ngValue]="null">
            {{ "PICK_AN_OPTION" | globalTranslate }}
          </option>
          @for (option of verificationStatusOptions; track option) {
          <option [ngValue]="option">
            {{ option.enDescription }}
          </option>
          }
        </select>
      </nh-field>
      @if (verificationStatus?.code === 'NV') {
      <div>
        <nh-field
          label="{{ 'ADDITIONAL_REVIEW_NOTES' | globalTranslate }}"
          [mandatory]="true"
          [attr.aria-required]="true"
          [labelSize]="false"
        >
          <span
            class="d-block pt-1"
            [innerHTML]="'RIDP_AHS_REVIEW_NOTE' | globalTranslate"
          ></span>
          <nh-count>
            <textarea
              [(ngModel)]="workerNotes"
              (input)="onInput($event)"
              maxlength="2000"
              placeholder="{{ 'NOTE_PLACEHOLDER' | globalTranslate }}"
              name="workerNotes"
              class="form-control"
              [attr.aria-label]="'ADDITIONAL_REVIEW_NOTES' | globalTranslate"
              rows="5"
              autofocus="true"
              style="margin-top: 5px"
              required
              [disabled]="isVerificationDisabled"
            ></textarea>
          </nh-count>
        </nh-field>
      </div>
      }
    </div>
    <div class="row mb-2 ml-1 me-1">
      <button
        id="continue"
        (click)="onSubmit()"
        [disabled]="isSubmitDisabled()"
        class="btn btn-secondary col-md-2 offset-md-9 ps-0"
      >
        {{ "SUBMIT" | globalTranslate }}
      </button>
    </div>
  </div>
  } @if (fromWp === false && reviewDocs === false) {
  <div class="bg-custom-register">
    <h2 class="section-header">
      {{ "RIDP_CALLCENTER_STATIC14" | globalTranslate }}
    </h2>
    <hr />
    <p>
      <span [innerHTML]="'RIDP_CALLCENTER_STATIC15' | globalTranslate"></span>
      <span
        ><b [innerHTML]="'RIDP_CALLCENTER_STATIC15_01' | globalTranslate"></b
      ></span>
    </p>
    @if (!mobileAppRidpUser) {
    <p>
      <span [innerHTML]="'RIDP_CALLCENTER_STATIC16' | globalTranslate"></span>
      <span
        ><b [innerHTML]="'RIDP_CALLCENTER_STATIC16_01' | globalTranslate"></b
      ></span>
      <span
        [innerHTML]="'RIDP_CALLCENTER_STATIC16_02' | globalTranslate"
      ></span>
    </p>
    } @if (mobileAppRidpUser) {
    <p [innerHTML]="'RIDP_CALLCENTER_STATIC16_MOBILE' | globalTranslate"></p>
    }
    <div class="mb-5 pt-4">
      <div class="d-flex align-items-center">
        <img
          src="../../../../../assets/images/ridp_doc_icon.svg"
          alt="documents"
          class="img-fluid mb-4 mt-2"
          aria-hidden="true"
          role="presentation"
        />
        <h3 class="section-header mb-4 ms-2">
          {{ "RIDP_VERIFY_DOC_SUBHEADER" | globalTranslate }}
        </h3>
      </div>
      <mat-accordion displayMode="" multi class="ridp-doc-accordion">
        <mat-expansion-panel class="ridp-expansion-panel" [expanded]="true">
          <mat-expansion-panel-header
            role="button"
            tabindex="0"
            class="mat-row ridp-expansion-header"
            hideToggle
          >
            <mat-panel-title class="ridp-panel-title">
              <h4 class="section-header">
                {{ "RIDP_PRIMARY_DOC_HEADER" | globalTranslate }}
              </h4>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="ridp-expanded-content">
            <div class="primary_doc_section">
              <p [innerHTML]="'RIDP_PRIMARY_DOC_TEXT' | globalTranslate"></p>
              <p [innerHTML]="'RIDP_PRIMARY_DOC_TEXT_02' | globalTranslate"></p>
              <p class="primary_doc_list pt-3">
                {{ "RIDP_PRIMARY_DOC_LIST_01" | globalTranslate }}
              </p>
              <p class="primary_doc_list">
                {{ "RIDP_PRIMARY_DOC_LIST_02" | globalTranslate }}
              </p>
              <ul class="doc-list" role="list">
                <li
                  role="listitem"
                  [innerHTML]="'RIDP_PRIMARY_DOC_LIST_03' | globalTranslate"
                ></li>
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_04" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_05" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_06" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_07" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_08" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_09" | globalTranslate }}
                </li>
              </ul>
              <p class="primary_doc_list">
                {{ "RIDP_PRIMARY_DOC_LIST_10" | globalTranslate }}
              </p>
              <p class="primary_doc_list">
                {{ "RIDP_PRIMARY_DOC_LIST_11" | globalTranslate }}
              </p>
              <p class="primary_doc_list">
                {{ "RIDP_PRIMARY_DOC_LIST_12" | globalTranslate }}
              </p>
              <ul class="doc-list" role="list">
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_13" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_PRIMARY_DOC_LIST_14" | globalTranslate }}
                </li>
              </ul>
              <p
                class="pt-3"
                [innerHTML]="'RIDP_WRITTEN_ATTESTATION_NOTE' | globalTranslate"
              ></p>
              <ul class="doc-list" role="list" id="written-statement">
                <li role="listitem">
                  {{ "RIDP_WRITTEN_ATTESTATION_EXAMPLES" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_WRITTEN_ATTESTATION_EXAMPLES_02" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_WRITTEN_ATTESTATION_EXAMPLES_03" | globalTranslate }}
                </li>
                <li role="listitem">
                  {{ "RIDP_WRITTEN_ATTESTATION_EXAMPLES_04" | globalTranslate }}
                </li>
              </ul>
              <hr />
              <div class="supporting_doc">
                <p class="section-header">
                  {{ "RIDP_SUPPORTING_DOC_HEADER" | globalTranslate }}
                </p>
                <p
                  [innerHTML]="'RIDP_SUPPORTING_DOC_TEXT' | globalTranslate"
                ></p>
                <ul class="doc-list" role="list">
                  <li role="listitem">
                    {{ "RIDP_SUPPORTING_DOC_LIST_01" | globalTranslate }}
                  </li>
                  <li role="listitem">
                    {{ "RIDP_SUPPORTING_DOC_LIST_02" | globalTranslate }}
                  </li>
                  <li role="listitem">
                    {{
                      getSupportingPaystubOverride() ||
                        ("RIDP_SUPPORTING_DOC_LIST_03" | globalTranslate)
                    }}
                  </li>
                  <li role="listitem">
                    {{ "RIDP_SUPPORTING_DOC_LIST_04" | globalTranslate }}
                  </li>
                  <li
                    role="listitem"
                    [innerHTML]="
                      'RIDP_SUPPORTING_DOC_LIST_05' | globalTranslate
                    "
                  ></li>
                </ul>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="modal-footer justify-content-between">
      <div>
        <button
          type="button"
          id="uploadBtn"
          class="btn btn-link"
          (click)="onUploadDocuments('fromInitialUploadDoc')"
        >
          {{ "WELCOME_MANAGE_UPLOAD_HEADER" | globalTranslate }}
        </button>
      </div>
      <div>
        @if (!mobileAppRidpUser) {
        <button
          type="button"
          id="dashboardBtn"
          class="btn btn-secondary"
          (click)="onGoToDashboard()"
        >
          {{ "RIDP_DASHBOARD_LINK_1" | globalTranslate }}
        </button>
        }
      </div>
    </div>
  </div>
  } @if (!fromWp && reviewDocs) {
  <div class="bg-custom-register">
    <div>
      <h2 class="section-header">
        {{ "RIDP_CALLCENTER_STATIC24" | globalTranslate }}
      </h2>
      <hr />
      <p>{{ "RIDP_CALLCENTER_STATIC25" | globalTranslate }}</p>
      <p>{{ "RIDP_CALLCENTER_STATIC26" | globalTranslate }}</p>
      @if (!mobileAppRidpUser) {
      <p>
        <span [innerHTML]="'RIDP_CALLCENTER_STATIC27' | globalTranslate"></span>
        <span
          ><b [innerHTML]="'RIDP_CALLCENTER_STATIC27_01' | globalTranslate"></b
        ></span>
      </p>
      } @if (mobileAppRidpUser) {
      <p [innerHTML]="'RIDP_CALLCENTER_STATIC27_MOBILE' | globalTranslate"></p>
      }
      <div class="pb-3 popup">
        <a
          title="{{ 'RIDP_UPLOADDOC_STATIC3' | globalTranslate }}"
          role="link"
          tabindex="0"
          (click)="showDocTypes()"
          (keydown.enter)="showDocTypes(); $event.preventDefault()"
          (keydown.space)="showDocTypes(); $event.preventDefault()"
        >
          <span class="pe-2">{{
            "RIDP_UPLOADDOC_STATIC3" | globalTranslate
          }}</span>
          <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
        </a>
      </div>
      <nh-alert type="danger" [isOpen]="notVerified && allAreErrorDocs">
        <div class="row">
          <div class="col-auto icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="37.5"
              height="37.5"
              viewBox="0 0 37.5 37.5"
            >
              <path
                id="Combined_Shape"
                data-name="Combined Shape"
                d="M0,18.749A18.75,18.75,0,1,1,18.749,37.5,18.771,18.771,0,0,1,0,18.749Zm2.885,0A15.865,15.865,0,1,0,18.749,2.885,15.883,15.883,0,0,0,2.885,18.749Zm20.638,6.812-.024-.022-4.749-4.75L14,25.539a1.442,1.442,0,0,1-2.063-2.016l.024-.024L16.71,18.75,11.961,14a1.442,1.442,0,0,1,2.016-2.063l.023.024,4.75,4.749L23.5,11.961a1.442,1.442,0,0,1,2.063,2.016L25.539,14l-4.75,4.75,4.75,4.749a1.442,1.442,0,0,1-2.016,2.063Z"
                fill="#da2325"
              />
            </svg>
          </div>
          <div class="col message">
            <span
              [innerHTML]="'RIDP_CALLCENTER_STATIC28' | globalTranslate"
            ></span>
            <span
              ><b
                [innerHTML]="'RIDP_CALLCENTER_STATIC28_01' | globalTranslate"
              ></b
            ></span>
            <span
              [innerHTML]="'RIDP_CALLCENTER_STATIC28_02' | globalTranslate"
            ></span>
          </div>
        </div>
      </nh-alert>
    </div>
    <div>
      <h2 class="section-header">
        {{ "RIDP_CALLCENTER_STATIC9" | globalTranslate }}
      </h2>
      <hr />
      <div class="d-none d-lg-block">
        <table class="table w-100 table-striped">
          <thead>
            <tr>
              <th scope="col">{{ "NAME" | globalTranslate }}</th>
              <th scope="col">{{ "DOCUMENT_TYPE" | globalTranslate }}</th>
              <th scope="col">{{ "UPLOAD_DATE" | globalTranslate }}</th>
              <th scope="col">{{ "Status" | globalTranslate }}</th>
              <th scope="col">{{ "View" | globalTranslate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (doc of submittedDocuments; track doc) {
            <tr>
              <td>{{ doc.name }}</td>
              <td style="width: 30%">
                {{ doc.documentType | globalTranslate }}
              </td>
              <td>{{ doc.uploadDate | date: "MM/dd/yyyy" }}</td>
              <td>
                @if (doc?.statusCd !== 'ERR') {
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17.5"
                    height="17.5"
                    viewBox="0 0 17.5 17.5"
                    style="margin-left: 2px"
                  >
                    <g id="time-outline" transform="translate(-63.25 -63.25)">
                      <path
                        id="Path_154"
                        data-name="Path 154"
                        d="M72,64a8,8,0,1,0,8,8A8,8,0,0,0,72,64Z"
                        fill="#ed9924"
                        stroke="#ed9924"
                        stroke-miterlimit="10"
                        stroke-width="1.5"
                      />
                      <path
                        id="Path_155"
                        data-name="Path 155"
                        d="M256,128v6h4"
                        transform="translate(-184 -61.333)"
                        fill="#ed9924"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      />
                    </g>
                  </svg>
                  &nbsp; <b>{{ doc.status | globalTranslate }}</b
                  >@if (doc.status) {
                  <nh-popover
                    class="ps-1"
                    content="{{ 'PENDING_REVIEW_TOOLTIP' | globalTranslate }}"
                  ></nh-popover>
                  }
                </span>
                } @if (doc?.statusCd === 'ERR') {
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="20"
                    viewBox="0 0 24 20"
                    style="vertical-align: top"
                  >
                    <g
                      id="Group_1613"
                      data-name="Group 1613"
                      transform="translate(-764 -1008)"
                    >
                      <path
                        id="Polygon_1"
                        data-name="Polygon 1"
                        d="M10.285,2.858a2,2,0,0,1,3.43,0l8.468,14.113A2,2,0,0,1,20.468,20H3.532a2,2,0,0,1-1.715-3.029Z"
                        transform="translate(764 1008)"
                        fill="#d7282f"
                      />
                      <path
                        id="Path"
                        d="M1.26,0H1.238A1.25,1.25,0,0,0,0,1.3l.33,7.025a.92.92,0,0,0,1.838,0L2.5,1.308A1.25,1.25,0,0,0,1.3,0H1.26Z"
                        transform="translate(774.75 1013.13)"
                        fill="#fff"
                      />
                      <path
                        id="Path-2"
                        data-name="Path"
                        d="M1.15,2.3A1.15,1.15,0,1,1,2.3,1.15,1.15,1.15,0,0,1,1.15,2.3Z"
                        transform="translate(774.851 1023.7)"
                        fill="#fff"
                      />
                    </g></svg
                  >&nbsp; <b>{{ doc.status | globalTranslate }}</b> @if
                  (doc.status) {
                  <nh-popover
                    class="ps-1"
                    content="{{ 'NOT_VERIFIED_TOOLTIP' | globalTranslate }}"
                  ></nh-popover>
                  }
                </span>
                }
              </td>
              <td>
                <a
                  class="btn btn-link view-link"
                  tabindex="0"
                  (click)="onViewPdf(doc.filenetId)"
                  >{{ "View" | globalTranslate }}
                  <i
                    class="fa fa-search"
                    aria-hidden="true"
                    [attr.aria-label]="'VIEW' | globalTranslate"
                  ></i
                ></a>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="nh-table-mobile d-lg-none">
        @if (submittedDocuments?.length) {
        <div>
          @for (row of submittedDocuments; track row) {
          <div class="table-row mb-3 pb-3">
            <div class="mobile-table-header">
              {{ "NAME" | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">{{ row.name }}</div>
            <br />
            <div class="mobile-table-header">
              {{ "DOCUMENT_TYPE" | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">{{ row.documentType }}</div>
            <br />
            <div class="mobile-table-header">
              {{ "UPLOAD_DATE" | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">
              {{ row.uploadDate | date: "MM/dd/yyyy" }}
            </div>
            <br />
            <div class="mobile-table-header">
              {{ "Status" | globalTranslate }}
            </div>
            <hr />
            <div class="mobile-table-data">
              @if (row?.status !== 'Not Verified') {
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17.5"
                  height="17"
                  viewBox="0 0 17.5 17.5"
                >
                  <g id="time-outline" transform="translate(-63.25 -63.25)">
                    <path
                      id="Path_154"
                      data-name="Path 154"
                      d="M72,64a8,8,0,1,0,8,8A8,8,0,0,0,72,64Z"
                      fill="#ed9924"
                      stroke="#ed9924"
                      stroke-miterlimit="10"
                      stroke-width="1.5"
                    />
                    <path
                      id="Path_155"
                      data-name="Path 155"
                      d="M256,128v6h4"
                      transform="translate(-184 -61.333)"
                      fill="#ed9924"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
                &nbsp; <b>{{ row.status }}</b
                >@if (row.status) {
                <nh-popover
                  class="ps-1"
                  content="{{ 'PENDING_REVIEW_TOOLTIP' | globalTranslate }}"
                ></nh-popover>
                }
              </span>
              } @if (row?.status === 'Not Verified') {
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="20"
                  viewBox="0 0 24 20"
                  style="vertical-align: top"
                >
                  <g
                    id="Group_1613"
                    data-name="Group 1613"
                    transform="translate(-764 -1008)"
                  >
                    <path
                      id="Polygon_1"
                      data-name="Polygon 1"
                      d="M10.285,2.858a2,2,0,0,1,3.43,0l8.468,14.113A2,2,0,0,1,20.468,20H3.532a2,2,0,0,1-1.715-3.029Z"
                      transform="translate(764 1008)"
                      fill="#d7282f"
                    />
                    <path
                      id="Path"
                      d="M1.26,0H1.238A1.25,1.25,0,0,0,0,1.3l.33,7.025a.92.92,0,0,0,1.838,0L2.5,1.308A1.25,1.25,0,0,0,1.3,0H1.26Z"
                      transform="translate(774.75 1013.13)"
                      fill="#fff"
                    />
                    <path
                      id="Path-2"
                      data-name="Path"
                      d="M1.15,2.3A1.15,1.15,0,1,1,2.3,1.15,1.15,1.15,0,0,1,1.15,2.3Z"
                      transform="translate(774.851 1023.7)"
                      fill="#fff"
                    />
                  </g></svg
                >&nbsp;<b>{{ row.status }}</b
                >@if (row.status) {
                <nh-popover
                  class="ps-1"
                  content="{{ 'NOT_VERIFIED_TOOLTIP' | globalTranslate }}"
                ></nh-popover>
                }
              </span>
              }
            </div>
            <br />
            <div class="mobile-table-header">
              {{ "View Document" | globalTranslate }}
            </div>
            <hr />
            <button
              class="btn btn-secondary btn-sm w-100"
              (click)="onViewPdf(row.filenetId)"
            >
              <span>{{ "View" | globalTranslate }} </span>@if (row.pageCount &&
              row.pageCount > 1) {
              <span
                >({{ row.pageCount }} {{ "Pages" | globalTranslate }})
              </span>
              }<i class="fa fa-search fa-lg"></i></button
            ><br />
          </div>
          }
        </div>
        }
      </div>
      <div class="modal-footer justify-content-between">
        <div>
          @if (notVerified && allAreErrorDocs) {
          <button
            type="button"
            id="uploadBtn"
            class="btn btn-link"
            (click)="onUploadDocuments('fromVerifyDocuments')"
          >
            {{ "WELCOME_MANAGE_UPLOAD_HEADER" | globalTranslate }}
          </button>
          }
        </div>
        <div>
          @if (!mobileAppRidpUser) {
          <button
            type="button"
            id="dashboardBtn"
            class="btn btn-secondary"
            (click)="onGoToDashboard()"
          >
            {{ "RIDP_DASHBOARD_LINK_1" | globalTranslate }}
          </button>
          }
        </div>
      </div>
    </div>
  </div>
  }
</div>
